import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { TemplateSelectionModalComponent } from '../components/template-selection-modal/template-selection-modal.component';
import { ProjectCompletionModal } from '../components/project-completion-modal/project-completion-modal';


//from project completion modal data
export interface ProjectCompletionModalData {
  currentProjectedDate?: Date;
  currentResponsibility?: string;
  projectId?: string;
  projectName?: string;
  responsibilities?: Array<{ name: string; id?: string }>;
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openTemplateSelectionModal(): Observable<any> {
    const dialogRef = this.dialog.open(TemplateSelectionModalComponent, {
      width: '520px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: ['template-selection-modal', 'custom-dialog-container'],
      disableClose: false, // Allow closing by clicking outside
      hasBackdrop: true,
      autoFocus: false,
      backdropClass: 'custom-dialog-backdrop',
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '150ms',
      position: {},
      data: {}
    });

    return dialogRef.afterClosed();
  }

  openProjectCompletionModal(data?: ProjectCompletionModalData): { dialogRef: any, result$: Observable<any> } {
    const dialogRef = this.dialog.open(ProjectCompletionModal, {
      width: '520px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: ['project-completion-modal', 'custom-dialog-container'],
      disableClose: false,
      hasBackdrop: true,
      autoFocus: false,
      backdropClass: 'hide-backdrop',
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '150ms',
      position: {},
      data: data || {}
    });

    // Return an observable that handles form submission
    const result$ = new Observable(observer => {
      dialogRef.componentInstance.formSubmitted.subscribe(result => {
        // Pass the result to the subscriber
        observer.next(result);
      });
      
      dialogRef.afterClosed().subscribe(() => {
        observer.complete();
      });
    });

    return { dialogRef, result$ };
  }
}
